import React from 'react';
import { Link } from 'react-router-dom';

import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import IconButton from '@mui/material/IconButton';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';

import { useAuth } from 'pages/Authorization';
import CurrentUserMenu from 'shared/components/CurrentUserMenu';
import DataEnvToggle from 'shared/components/DataEnvToggle';

function AppBarNav() {
  const { handleLogout } = useAuth();

  return (
    <AppBar
      position="fixed"
      sx={{
        zIndex: 'modal',
        backgroundColor: 'rgba(255, 255, 255, 0.8)',
        backdropFilter: 'blur(8px)',
        borderBottom: '1px solid',
        borderColor: 'divider',
        boxShadow: 'none',
        color: 'text.primary',
      }}
    >
      <Toolbar>
        <Box
          component={Link}
          to="/"
          aria-label="SBLY Tools home"
          sx={{
            display: 'flex',
            alignItems: 'center',
            flexGrow: 1,
            color: 'inherit',
            textDecoration: 'none',
            borderRadius: 1,
            '&:focus-visible': {
              outline: '2px solid #6366F1',
              outlineOffset: 3,
            },
          }}
        >
          <img
            src="https://sbly.com/sbly-logo.svg"
            alt="SBLY"
            style={{ height: '32px', width: 'auto' }}
          />
          <Box
            aria-hidden="true"
            sx={{ width: '1px', height: 24, backgroundColor: 'divider', mx: 2 }}
          />
          <Typography
            component="span"
            noWrap
            sx={{
              fontSize: '0.875rem',
              lineHeight: 1,
              fontWeight: 700,
              color: '#2F0066',
              letterSpacing: '0.12em',
            }}
          >
            TOOLS
          </Typography>
        </Box>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <DataEnvToggle />
          <CurrentUserMenu />
          <IconButton
            onClick={handleLogout}
            sx={{
              color: 'text.secondary',
              borderRadius: 2,
              '&:hover': {
                color: 'text.primary',
                backgroundColor: '#F1F5F9',
              },
            }}
          >
            <ExitToAppIcon fontSize="small" />
          </IconButton>
        </Box>
      </Toolbar>
    </AppBar>
  );
}

export default AppBarNav;
